"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizUnprocessableEntityError = void 0;
const client_library_1 = require("@seneca/client-library");
class QuizUnprocessableEntityError extends client_library_1.ExtendableError {
    constructor(id) {
        super(`quiz: id ${id} cannot be duplicated`);
        this.id = id;
    }
}
exports.QuizUnprocessableEntityError = QuizUnprocessableEntityError;
//# sourceMappingURL=QuizUnprocessableEntityError.js.map